import { Injectable, OnInit } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';

const INTERNAL_USER_ROLE_MAPPINGS = {
    1: 'Parrot Admin',
    2: 'DP Admin',
    3: 'User',
    4: 'TMS Admin',
    5: 'Dev Demo',
    6: 'Mapping Approver',
    7: 'Helpdesk Title Creator',
    100: 'External Harvester'
};

const DATA_API_PERMISSIONS = {
    PORTAL_ADMIN: 'Portal Admin',
    PORTAL_VIEWER: 'Portal Viewer',
    HELPDESK_ADMIN: 'Helpdesk Admin',
    HELPDESK_VIEWER: 'Helpdesk Viewer',
    HELPDESK_TITLE_CREATOR: 'Helpdesk Title Creator',
    HELPDESK_TITLE_NAME_CHANGE: 'Helpdesk Title Name Change',
    SUPPORT_ACCOUNT: 'Support Account',
    PARROT_ADMIN: 'Parrot Admin',
    BRAND_AFFINITY_ACCESS: 'Brand Affinity Access',
    EXTERNAL_API: 'External API',
    HELPDESK_ACCOUNT_MANAGEMENT: 'Helpdesk Account Management',
    TV_DEMAND_API_CUSTOM_DATA_EXPORT : 'TV Demand API & Custom Data Export',
    MOVIE_DEMAND_API_CUSTOM_DATA_EXPORT : 'Movie Demand API & Custom Data Export',
    TALENT_DEMAND_API_CUSTOM_DATA_EXPORT : 'Talent Demand API & Custom Data Export',
};

@Injectable()
export class UserDetailsService implements OnInit {
    private permissions = [];
    private user: string;
    private username: string;
    private expiresAt: number;

    // From localstorage
    private jwt: string;
    private isDataApiUser: boolean;

    private jwtHelper = new JwtHelper();

    constructor() {}

    ngOnInit() {
        this.updateFromLocalStorage();
    }

    private updateFromLocalStorage() {
        const jwt = localStorage.getItem('id_token');
        if (!this.jwt || this.jwt !== jwt) {
            this.isDataApiUser = localStorage.getItem('is_data_api_user') === 'true';
            this.username = localStorage.getItem('userName');
            if (jwt) {
                const decodedJwt = this.jwtHelper.decodeToken(jwt);
                this.parseJwt(decodedJwt);
            }
        }
    }

    private parseJwt(jwtObject) {
        this.user = jwtObject['pun'];
        this.expiresAt = jwtObject['exp'];
        this.permissions = jwtObject['pur'].map((item) => this.isDataApiUser ?
            item.authority : INTERNAL_USER_ROLE_MAPPINGS[item.authority]);
    }

    getPermissions() {
        this.updateFromLocalStorage();
        return this.permissions;
    }

    isAdmin() {
        this.updateFromLocalStorage();
        if (this.isDataApiUser) {
            return this.permissions.includes(DATA_API_PERMISSIONS.HELPDESK_ADMIN);
        } else {
            return this.permissions.includes(INTERNAL_USER_ROLE_MAPPINGS[1]);
        }
    }

    isMappingApprover() {
        this.updateFromLocalStorage();
        if (this.isDataApiUser) {
            return this.permissions.includes(DATA_API_PERMISSIONS.HELPDESK_ADMIN);
        } else {
            return this.permissions.includes(INTERNAL_USER_ROLE_MAPPINGS[6]);
        }
    }

    isTitleCreationApprover() {
        this.updateFromLocalStorage();
        if (this.isDataApiUser) {
            return this.permissions.includes(DATA_API_PERMISSIONS.HELPDESK_TITLE_CREATOR);
        } else {
            return this.permissions.includes(INTERNAL_USER_ROLE_MAPPINGS[7]);
        }
    }

    isTitleNameChanger() {
        this.updateFromLocalStorage();
        if (this.isDataApiUser) {
            return this.permissions.includes(DATA_API_PERMISSIONS.HELPDESK_TITLE_NAME_CHANGE);
        } else {
            // External users cannot change title names
            return false;
        }
    }

    isHelpdeskAccountManager() {
        this.updateFromLocalStorage();
        if (this.isDataApiUser) {
            return this.permissions.includes(DATA_API_PERMISSIONS.HELPDESK_ACCOUNT_MANAGEMENT);
        } else {
            // External users cannot change title names
            return false;
        }
    }

    getUser() {
        return this.user;
    }

    getUsername() {
        return this.username;
    }

    getCachedUserName(){
        return localStorage.getItem('userName');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user.details.service.ts